import React, { useEffect, useState } from "react";

import { DataCodeEnum } from "../../../../../constants/enum";
import DataContent from "../../../../../components/DataContent";

const SignsTheirElements: React.FC = () => {
  return (
    <DataContent
      code={DataCodeEnum.ZODIAC_SIGN_THEIR_ELEMENTS}
      name="Zodiac Signs and Their Elements"
      fields={[
        {
          code: "name",
          name: "Name",
        },
        {
          code: "sign_ruled",
          name: "Signs Ruled",
        },
        {
          code: "on_a_good_day",
          name: "On a Good Day",
        },
        {
          code: "on_a_bad_day",
          name: "On a Bad Day",
        },
        {
          code: "how_to_win",
          name: "How to Win",
        },
      ]}
    />
  );
};

export default SignsTheirElements;
